export default {
  path: "/app/document-out",
  name: "document-out",
  redirect: "/app/document-out/list",
  component: () => import("./layout"),
  children: [
    {
      path: "list",
      name: "listDocumentOut",
      component: () =>
        import("./components/listDocument/list-document-out.created-by-me"),
      meta: {
        appName: "listDocumentOut",
      },
    },
    {
      path: "list-wait-process",
      name: "listDocumentOutWaitProcess",
      component: () =>
        import("./components/listDocument/list-document-out.wait-process"),
      meta: {
        appName: "listDocumentOutWaitProcess",
      },
    },
    {
      path: "list-wait-approval",
      name: "listDocumentOutWaitApproval",
      component: () =>
        import("./components/listDocument/list-document-out.wait-approval"),
      meta: {
        appName: "listDocumentOutWaitApproval",
      },
    },
    {
      path: "list-has-approved",
      name: "listDocumentOutHasApproved",
      component: () =>
        import("./components/listDocument/list-document-out.has-approval"),
      meta: {
        appName: "listDocumentOutHasApproved",
      },
    },
    {
      path: "list-my-approved",
      name: "listDocumentOutMyApproved",
      component: () =>
        import("./components/listDocument/list-document-out.approved"),
      meta: {
        appName: "listDocumentOutMyApproved",
      },
    },
    {
      path: "list-department-manager",
      name: "listDocumentOutDepartmentManager",
      component: () =>
        import(
          "./components/listDocument/list-document-out.department-manager"
        ),
      meta: {
        appName: "listDocumentOutDepartmentManager",
      },
    },
    {
      path: "list-all-document-out",
      name: "listAllDocumentOut",
      component: () =>
        import("./components/listDocument/list-document-out.all-document"),
      meta: {
        appName: "listAllDocumentOut",
      },
    },
    {
      path: "list-all-document-out/export",
      name: "listAllDocumentOutExport",
      component: () =>
        import(
          "./components/listDocument/list-document-out.all-document.export"
        ),
    },

    {
      path: "detail/:idDocument",
      name: "detailDocumentOut",
      component: () =>
        import("./components/detail-view/document-out.detail-page"),
    },
    {
      path: "detail-process/:idDocument",
      name: "detailProcessDocumentOut",
      component: () =>
        import("./components/detail-view/document-out.detail-process"),
    },
    {
      path: "detail-approval/:idDocument",
      name: "detailApprovalDocumentOut",
      component: () =>
        import("./components/detail-view/document-out.detail-approval"),
    },

    {
      path: "update/:idDocument",
      name: "updateDocumentOut",
      component: () => import("./document-out.update-page"),
    },
    {
      path: "r/:idDocument",
      name: "redirectDocumentOut",
      component: () => import("./document-out.redirect-view"),
    },
    {
      path: "add",
      name: "addDocumentOut",
      component: () => import("./document-out.add-page"),
    },
  ],
};
